import React from "react";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {Container , Row , Col , Image} from "react-bootstrap";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";

function Error404(props) {
    return (
        <>
            <Loading/>
            <ProgressScrollButton/>
            <Navigation/>
            <main>
                <section className="error-404 pb-70">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={5} md={8}>
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/404.svg"}  alt=""/>
                                </div>
                                <div className="cont text-center">
                                    <h3>صفحه مورد نظر یافت نشد!</h3>
                                    <a href={process.env.REACT_APP_BASE_URL + "/"} className="butn butn-md main-colorbg3 radius-30 mt-50">
                                        <span className="text-dark fw-600">بازگشت به خانه</span>
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <footer className="pt-80  sub-bg">
                <FooterBody/>
                <CopyRight/>
            </footer>
        </>
    );
}

export default Error404;
